// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"d712baf4","565":"b0aa44c4","795":"4424c2a1"}[chunkId] + ".chunk.css";
};